module.exports = __webpack_public_path__ + "static/trees-3.4-1e69f96e26aaf2f9a626616c9fd54118.png";